import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';
import metadata from './block.json';
import Edit from './Edit';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  // Dynamic: the per-term price and CTA nodes are built from the `prices`
  // array, and the CTA falls back to the first term's when a later one is
  // blank — both decisions belong at render time, not in saved markup.
  save: () => <InnerBlocks.Content />,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="5" y="3.5" width="14" height="17" rx="2" />
        <path d="M8.5 8h7M8.5 12h4M8.5 16.5h7" />
      </svg>
    ),
  },
});
